package br.com.texeratx.boardgametimeapp.ui.screens.dashboard.model

data class LastMatchesUI(
    val matchId: Long,
    val gameName: String,
    val gameImageUrl: String?,
    val date: String,
    val duration: Int,
    val players: List<String>
)
